import * as React from "react";
import ProjetoTopo from "./topo";
import { ProjetoDetalhe } from "./detalhe";
import { ProjetoBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const ProjetoPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.projects.titlePage"));

  return (
    <React.Fragment>
      <ProjetoDetalhe />
      <ProjetoBottom />
    </React.Fragment>
  );
};
